import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddMembersToTeamMutationVariables = Types.Exact<{
  data: Types.AddMembersToTeamInput;
}>;


export type AddMembersToTeamMutation = { __typename?: 'Mutation', addMembersToTeam: { __typename?: 'OrganisationTeam', id: string, uuid: string, members: Array<{ __typename?: 'OrganisationTeamMember', id: string, role: Types.OrganisationTeamRole }> } };


export const AddMembersToTeamDocument = gql`
    mutation AddMembersToTeam($data: AddMembersToTeamInput!) {
  addMembersToTeam(data: $data) {
    id
    uuid
    members {
      id
      role
    }
  }
}
    `;
export type AddMembersToTeamMutationFn = Apollo.MutationFunction<AddMembersToTeamMutation, AddMembersToTeamMutationVariables>;

/**
 * __useAddMembersToTeamMutation__
 *
 * To run a mutation, you first call `useAddMembersToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMembersToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMembersToTeamMutation, { data, loading, error }] = useAddMembersToTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddMembersToTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddMembersToTeamMutation, AddMembersToTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMembersToTeamMutation, AddMembersToTeamMutationVariables>(AddMembersToTeamDocument, options);
      }
export type AddMembersToTeamMutationHookResult = ReturnType<typeof useAddMembersToTeamMutation>;
export type AddMembersToTeamMutationResult = Apollo.MutationResult<AddMembersToTeamMutation>;
export type AddMembersToTeamMutationOptions = Apollo.BaseMutationOptions<AddMembersToTeamMutation, AddMembersToTeamMutationVariables>;